<template>
	<div style="position: relative;z-index: 20;">
		<div class="main-button" 
			:class="{
				'has-label':menuLabel, 
				'justify-content-center': !menuLabel,
				'has-border' : buttonBorder
			}" 
			v-on:click="openMenu">

			<i v-if="!iconRight" class="icon-button fa" :class="icon ? icon : 'fa-ellipsis-v'"></i>
			<div v-if="menuLabel" class="label">{{menuLabel}}</div>
			<i v-if="iconRight" class="icon-button fa" :class="icon ? icon : 'fa-ellipsis-v'"></i>
		</div>

		<ul v-if="menuOpen" v-click-outside="closeMenu" class="menu" :style="{width: width ? width : '200px'}">
			<li v-for="item in menuItems" 
				v-on:click="itemClick(item.clickFunction,item)" 
				:class="itemClass(item)">
				<i v-if="'icon' in item" class="fa fa-fw" :class="item.icon"></i>
				{{item.text}}
			</li>
		</ul>
	</div>
</template>

<script>
import CustomDirectives from "@/mixins/CustomDirectives.js"

export default {

	name: 'ContextMenu',
	props: [
		"menuItems",
		"menuLabel",
		"width",
		"icon",
		"iconRight",
		"buttonBorder"
	],
	mixins: [CustomDirectives],
	data() {
		return {
			menuOpen: false,
			clickOutsideActive: false
		}
	},
	methods: {
		itemClass(item) {
			let classText = ""
			if ('itemClass' in item)
				classText = item.itemClass

			if ("disabled" in item && item.disabled)
				classText += " disabled text-muted"

			if ("isDivider" in item && item.isDivider)
				classText += " is-divider"

			return classText
		},
		openMenu() {
			this.menuOpen = true
			this.clickOutsideActive = false
			this.runClickOutsideActiveTimer()
		},
		closeMenu() {
			if (this.clickOutsideActive) {
				this.menuOpen = false
				this.$emit("closeMenu")
			}
		},
		itemClick(clickFunction,item) {
			if (!("disabled" in item) || !item.disabled) {
				this.$emit("itemClick",clickFunction,item)
				this.$emit(clickFunction,item)
				this.menuOpen = false;
			}
		},
		runClickOutsideActiveTimer() {
			let vm = this
			setTimeout(() => {
				vm.clickOutsideActive = true
			},200)
		}
	},
	created() {
		let vm = this
		this.runClickOutsideActiveTimer()
	}
}
</script>

<style type="text/css" scoped>

	.main-button {
		text-align: center;
		width: 30px;
		height: 27px;
		padding-top: 3px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.main-button.has-border {
		border: 1px solid gray;
		padding: 3px;
		padding-right: 5px;
		padding-left: 5px;
		border-radius: 4px;
	}

	.main-button.has-border .icon-button {
		font-size: 12pt;
	}

	.main-button.has-label {
		width: auto;
	}

	.main-button .label {
		margin-left: 10px;
		margin-right: 10px;
	}

	.menu {
		position: absolute;
		top: 30px;
		border: 1px solid #e0e0e0;
		background-color: white;
		margin: 0;
		padding: 0;
		right: -0;
		z-index: 20;
		width: 200px;
		box-shadow: 0 1px 3px gray;
	}

	li {
		padding: 5px;
		padding-left: 10px;
		padding-right: 10px;
	}

	li:hover {
		background-color: #e0e0e0;
		cursor: pointer;
	}

	li.disabled {
		cursor: not-allowed;
	}

	li.is-divider {
		cursor: not-allowed;
		border-bottom: 1px solid #e0e0e0;
		padding-top: 0;
		padding-bottom: 0;
	}

	li.is-divider:hover {
		background-color: transparent;
	}

	ul {
		list-style: none;
	}

</style>